import { NgModule } from '@angular/core';
import { MsInputSwitchComponent } from './ms-input-switch.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsInputSwitchComponent],
	imports: [SharedLibsModule],
	exports: [MsInputSwitchComponent],
	providers: [],
})
export class MsInputSwitchModule {}
